var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { CustomFilterService } from 'path-shared/services/datasource/custom-filter-service';
import { HttpParams } from '@angular/common/http';
var defaultSortParam = 'codi';
var defaultSortDirection = 'asc';
var SenseRetiradaGruaFilterService = /** @class */ (function (_super) {
    __extends(SenseRetiradaGruaFilterService, _super);
    function SenseRetiradaGruaFilterService() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    SenseRetiradaGruaFilterService.prototype.createFilterParams = function (filter, start, pageSize, sortField, sortDir) {
        return new HttpParams()
            .append('matricula', filter.matricula)
            .append('marca', filter.marca)
            .append('modelo', filter.modelo)
            .append('idNoRetirada', filter.idNoRetirada)
            .append('dataInici', filter.dataInici ? filter.dataInici.toUTCString() : null)
            .append('dataFi', filter.dataFi ? filter.dataFi.toUTCString() : null)
            .append('start', start.toString())
            .append('size', pageSize.toString())
            .append('sortparam', sortField === undefined ? defaultSortParam : sortField)
            .append('sortdir', sortDir === '' ? defaultSortDirection : sortDir);
    };
    return SenseRetiradaGruaFilterService;
}(CustomFilterService));
export { SenseRetiradaGruaFilterService };
